import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import Toolbar from "../src/components/Toolbar/Toolbar";
import NoMatch from "./components/NoMatch/NoMatch";
import SideDrawer from "./components/SideDrawer/SideDrawer";
import Backdrop from "./components/UI/Backdrop/Backdrop";
import Modal from "./components/UI/Modal/Modal";
import SearchFields from "./containers/SearchFields/SearchFields";
import styles from "./Main.module.css";
import * as actionTypes from "./store/actions";
import Login from "./containers/Login/Login";

function Loading({ error }) {
  if (error) return "Oh nooess!";
  return <h3>Loading...</h3>;
}

class App extends Component {
  state = { activeClass: "normal" };

  componentDidMount() {
    window.addEventListener("scroll", () => {
      let activeClass = "normal";
      if (window.scrollY > 70 && this.state.activeClass !== "top") activeClass = "top";
      this.setState({ ...this.state, activeClass });
      if (window.scrollY <= 70 && this.state.activeClass === "top") this.setState({ ...this.state, activeClass });
    });
  }

  LoadHome = Loadable({ loader: () => import("./containers/Home/Home"), loading: Loading });
  LoadRegion = Loadable({ loader: () => import("./containers/Region/Region"), loading: Loading });
  LoadServices = Loadable({ loader: () => import("./components/Services/Services"), loading: Loading });
  LoadAdminPage = Loadable({ loader: () => import("./containers/AdminPage/AdminPage"), loading: Loading });
  LoadContactForm = Loadable({ loader: () => import("./containers/ContactForm/ContactForm"), loading: Loading });
  LoadUserSetting = Loadable({ loader: () => import("./containers/UserSettings/UserSetting"), loading: Loading });
  LoadSearch = Loadable({ loader: () => import("./containers/Search/Search"), loading: Loading });
  LoadPost = Loadable({ loader: () => import("./containers/Post/Post"), loading: Loading });
  LoadRelatedPosts = Loadable({ loader: () => import("./containers/RelatedPosts/RelatedPosts"), loading: Loading });
  LoadEvents = Loadable({ loader: () => import("./containers/Events/Events"), loading: Loading });
  LoadRegister = Loadable({ loader: () => import("./containers/Register/Register"), loading: Loading });

  TermsOfUse = Loadable({ loader: () => import("./components/TermsOfUse/TermsOfUse"), loading: Loading });
  Impressum = Loadable({ loader: () => import("./components/Impressum/Impressum"), loading: Loading });

  render() {
    // Login modal
    const loginModal = (
      <Modal show={this.props.loginOpen} close={this.props.hadnleTogleLogin} size={400}>
        <Login />
      </Modal>
    );

    let sideDrawer = <SideDrawer show={this.props.sideDrawerOpen} />;
    let backdrop;

    if (this.props.sideDrawerOpen) {
      sideDrawer = (
        <SideDrawer
          show={this.props.sideDrawerOpen}
          loginClicked={this.props.hadnleTogleLogin}
          registrationClicked={this.props.hadnleTogleRegistration}
        />
      );
      backdrop = <Backdrop show={this.props.sideDrawerOpen} click={this.props.drawerToggleClickHandler} />;
    }

    return (
      <div className={styles.All}>
        {loginModal}
        <Toolbar
          drawerClickHandler={this.props.drawerToggleClickHandler}
          loginClicked={this.props.hadnleTogleLogin}
          registartionClicked={this.props.hadnleTogleRegistration}
          loggedInUser={this.props.user}
          appMenuClass={this.state.activeClass}
        />
        {this.props.location.pathname === "/contact" ? null : <SearchFields />}
        {sideDrawer}
        {backdrop}
        <Switch>
          <Route exact path="/" component={this.LoadHome} />
          <Route path="/region" component={this.LoadRegion} />
          <Route path="/service" component={this.LoadServices} />
          <Route path="/admin-page" component={this.LoadAdminPage} />
          <Route path="/contact" component={this.LoadContactForm} />
          <Route path="/settings" component={this.LoadUserSetting} />
          <Route path="/search" component={this.LoadSearch} />
          <Route path="/post/:id" component={this.LoadPost} />
          <Route path="/related/:tag" component={this.LoadRelatedPosts} />
          <Route path="/events" component={this.LoadEvents} />
          <Route path="/register" component={this.LoadRegister} />
          <Route path="/termsofuse" component={this.TermsOfUse} />
          <Route path="/impressum" component={this.Impressum} />
          <Route component={NoMatch} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  loginOpen: state.loginOpen,
  registrationOpen: state.registrationOpen,
  sideDrawerOpen: state.sideDrawerOpen,
});

const mapDispatchToProps = (dispatch) => ({
  hadnleTogleLogin: () => dispatch({ type: actionTypes.TOGGLE_LOGIN }),
  hadnleTogleRegistration: () => dispatch({ type: actionTypes.TOGGLE_REGISTRATION }),
  drawerToggleClickHandler: () => dispatch({ type: actionTypes.TOGGLE_DRAWER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
